module.exports = __webpack_public_path__ + "img/undraw_Designer_by46.ba6575fe.svg";